<!-- <div *ngIf="userType === 'Admin' || userType === 'User'">
    <p><strong>First Name: </strong> {{profile?.givenName}}</p>
    <p><strong>Last Name: </strong> {{profile?.surname}}</p>
    <p><strong>Email: </strong> {{profile?.userPrincipalName}}</p>
    <p><strong>Id: </strong> {{profile?.id}}</p>
</div> -->
<form id="addCategoryForm" (ngSubmit)="AddCategory()">
    <div class="row">
        <div class="col-sm-3" style="text-align: right; font-weight: bold;">Enter a cateory (5 or more letters):</div>
        <div class="col-sm-6" style="align-content: left;"><input id="category" type="text" [formControl]="category" (keyup)="enableAddButton()" size="40"/></div>
        <div class="col-sm-3" style="align-content:flex-start;">
            <button id="addCategoryButton" type="submit" disabled>Add</button>
            <label id="message" style="color: red; font:bolder;" ngModel="message">{{message}}</label>
        </div>
    </div>
</form>
<hr>
<p>
    
    Category List:
</p>
<mat-table class="lessons-table mat-elevation-z8" [dataSource]="categoryList">

    <ng-container matColumnDef="seqNo">
        <mat-header-cell *matHeaderCellDef>Seq.</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="categoryID">
        <mat-header-cell *matHeaderCellDef>Category ID</mat-header-cell>
        <mat-cell *matCellDef="let category">{{category.categoryID}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
        <mat-cell class="description-cell" *matCellDef="let category">
            <form id="updateCategoryForm" method="post" (ngSubmit)="UpdateCategory()">
                <input id="description_{{category.categoryID}}" type="text" value="{{category.description}}" [disabled]="isDisabled" size='40'/>
                <!-- <input type="hidden" id="categoryID" value="{{category.categoryID}}" [formControl]="categoryID"> -->
                <!-- <input type="button" id="change_{{category.categoryID}}" value="Change" (click)="toggleText(category.categoryID)">
                <input type="button" id="update_{{category.categoryID}}" value="Update" (click)="updateCategory(category.categoryID)" disabled> -->
            </form>
        </mat-cell>

    </ng-container>

    <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell class="status-cell" *matCellDef="let category">
            <lable id="lableStatus_{{category.categoryID}}" *ngIf="category.active==='Active'">{{category.active}}</lable>
            <lable id="lableStatus_{{category.categoryID}}" *ngIf="category.active==='Inactive'" style="color: red; font-weight: bolder;">{{category.active}}</lable>
            <select id="status_{{category.categoryID}}" style="visibility: hidden;" (ngModle)="statusSelected_(category.categoryID)">
                <option [ngSelected]="category.active=='Active'">Active</option>
                <option [ngSelected]="category.active=='Inactive'">Inactive</option>
            </select>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
        <mat-cell class="action-cell" *matCellDef="let category">
            <form id="updateCategoryForm" method="post" *ngIf="category.active==='Active'" (ngSubmit)="UpdateCategory()">
                <input type="button" id="change_{{category.categoryID}}" value="Change" (click)="toggleText(category.categoryID, category.active)">
                <input type="button" id="update_{{category.categoryID}}" value="Update" (click)="updateCategory(category.categoryID)" disabled>
            </form>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns" style="color:darkgray; font: bold;"></mat-header-row>

    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

</mat-table>

